import { useContext } from "react"
import { Typography } from "@stardust-ds/react"
import intl from "react-intl-universal"

import styles from "./index.module.scss"
import { fnBrightnessLevel } from "../../../utils/brightnessLevel"
import RcmpCardUsers from "../../atoms/CardUsers"
import { fnBisAdmin } from "../../../utils/permissions"
import RcmpCardEllipsis from "../../atoms/Ellipsis"
import usePanelMenu from "../../../hooks/usePanelMenu"
//import MembersIcon from "../../../assets/icons/MembersIcon"
//import ActivitiesIcon from "../../../assets/icons/ActivitiesIcon"

export default function RcmpPanelCard(props) {
  const { oCard, ...oRest } = props

  const aPanelMenuOptions = usePanelMenu(oCard)

  const cNameColor = fnBrightnessLevel(oCard?.color) > 220 ? "#000" : "#fff"

  return (
    <>
      <div
        className={styles.cardsContainer}
        {...oRest}
      >
        <div
          className={styles.cardHeader}
          style={{ background: `${oCard?.color || "#3977D0"}` }}
        >
          <Typography
            type="h3"
            className="highlightFilterText"
            color={cNameColor}
          >
            {oCard?.name}
          </Typography>
          {fnBisAdmin() && (
            <RcmpCardEllipsis
              aOptions={aPanelMenuOptions}
              fill={cNameColor}
            />
          )}
        </div>
        <div className={styles.cardContent}>
          <div className={styles.description}>
            <Typography
              className="highlightFilterText"
              type="p3"
              textAlign="justify"
            >
              {oCard?.description}
            </Typography>
          </div>
          <div className={styles.responsibles}>
            <RcmpCardUsers cLabel={intl.get("DashboardPage.responsibles")} aUsers={oCard?.responsibles} />
          </div>
          {/* <div className={styles.aboutCard}>
            <div className={styles.members}>
              <MembersIcon fill="#6CB6E3" width="23px" heigth="23px" />
              <Typography color="#415364" type="l5">
                {" "}
                {members || 0} Membros
              </Typography>
            </div>
            <div className={styles.activities}>
              <ActivitiesIcon fill="#6CB6E3" width="23px" heigth="23px" />
              <Typography color="#415364" type="l5">
                {" "}
                15 Atividades
              </Typography>
            </div>
          </div> */}
        </div>
      </div>
    </>
  )
}
